import { ApiCashBackModel, CashBackModel } from '../models';

export const mapCashBack = (bonuses: ApiCashBackModel): CashBackModel => ({
  points: Number(bonuses.bonus_points),
  percent: Number(bonuses.percent),
});
